export default __webpack_public_path__ + "static/media/appModepopupCard.7a81b0ca.png";